exports.NumTwoPoint = (value) => { // 全局过滤保留小数点后两位
	if (value == undefined || value == 0) {
		return '0.00'
	}
	return Number(value).toFixed(2);
};



// WEBPACK FOOTER //
// ./src/filter/index.js